import React, {Component} from 'react';
import {observer} from 'mobx-react'
import localStyles from './index.css';
import fonts from '../../../../../iconfonts.css';
import {Bubbles,Popup} from '../index';
import settings from '../../../../stores/cultureSettings.json';

@observer
export default class Silo extends Component{
    state = {active:false};
    coords(e){
        let target = e.target;
        let X = target.getBoundingClientRect().right + 5;
        let Y = target.getBoundingClientRect().top - 7;
        this.setState({active:true,x:X,y:Y})
    }
    
    render() {
        let item = this.props.item;
        let per = Math.ceil(item.amount / (item.totalCapacity * settings[item.culture].volume) * 100);
        let levelHeight = {height: per + '%'};
        let siloHeight = {height: item.totalCapacity / 5000 * 100 + '%'};
        let moisture = Math.round(item.moistureLevel * 10) / 10;
        let waste = Math.round(item.wasteLevel * 10) / 10;
        return (
            <div className={
                localStyles.siloUnit + ' '
                + (item.culture ? ' ' + localStyles[item.culture] : ' ' + localStyles.idle)
                + (( per < 90 && per > 30 && item.amountState === 'increasing') ? ' ' + localStyles.increasing : '')
                + (( per > 30 && item.amountState === 'decreasing') ? ' ' + localStyles.decreasing : '')
                + (( per > 10 && item.amountState === 'decreased') ? ' ' + localStyles.decreased : '')
                + (( per > 10 && item.amountState === 'increased') ? ' ' + localStyles.increased : '')
                + (( per > 90 && item.amountState === 'increasing') ? ' ' + localStyles.increased : '') /* это временный */
                + (this.props.inPath ? ' ' + localStyles.inPath : '')
            } style={this.props.inPath ? null : siloHeight}
                 onMouseOver={this.coords.bind(this)} onMouseLeave={()=>this.setState({active:false})}
            >
                <div className={localStyles.siloLevel} style={levelHeight}>
                    <div className={localStyles.siloBubbles}>
                        <Bubbles />
                    </div>
                    <div className={localStyles.siloLineOutput}/>
                </div>
                <div className={localStyles.siloNumbers}>
                    <span>{Math.ceil(item.amount)}</span>
                    <hr/>
                    <span>{Math.ceil(item.totalCapacity * settings[item.culture].volume)}</span>
                </div>
                <div className={localStyles.siloCulture}>
                    <i className={fonts[item.culture]}/>
                </div>
                <div className={localStyles.siloDSNumbers}>
                    <div>{waste}%</div>
                    <div>{moisture}%</div>
                </div>
                {this.state.active ?
                    <Popup x={this.state.x} y={this.state.y} item={item}/> : null
                }
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/shared/components/Game/SubComponents/Silo/index.js